import { IPaymentMethodNameEnum } from "../interfaces/Payments";

export const translatePaymentOnlineDone: {
	[key in IPaymentMethodNameEnum]: string
} = {
	creditCard: 'Cartão de Crédito',
	pix: 'Pagamento via Pix',
	wallets: 'Pagamento em carteira',
}
